var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProjectDetailsStatusSatelliteDish(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.42175 2.51921L7.56925 3.99587C5.14425 3.26337 2.97425 3.62087 2.22675 4.91671C1.24508 6.61671 2.88508 9.62671 6.12508 11.4975C9.36508 13.3684 12.7917 13.2825 13.7734 11.5834C14.5217 10.2875 13.7459 8.23004 11.8992 6.49587L12.7517 5.01921C15.3201 7.27671 16.4709 10.2442 15.2167 12.4167C13.6667 15.1017 9.22591 15.2125 5.29175 12.9417C1.35758 10.6684 -0.766586 6.76754 0.783414 4.08337C2.03758 1.91087 5.18341 1.42337 8.42175 2.51921ZM11.2367 0.977539L12.6801 1.81087L8.51341 9.02754L7.07008 8.1942L11.2367 0.977539V0.977539ZM3.61008 16.1667H12.1667V17.8334H2.18091C2.03216 17.8363 1.88536 17.7992 1.75589 17.7259C1.62642 17.6526 1.51907 17.5458 1.44508 17.4167C1.37235 17.2899 1.33408 17.1462 1.33408 17C1.33408 16.8538 1.37235 16.7102 1.44508 16.5834L3.32008 13.3359L4.76341 14.1692L3.61008 16.1667Z",
    fill: "#A1B3C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectDetailsStatusSatelliteDish);
export default __webpack_public_path__ + "static/media/project-details-status-satellite-dish.18dc259a21a3780b5c263e1e3cbd5cb6.svg";
export { ForwardRef as ReactComponent };